import { Experiment } from 'app/shared/typings/featureFlags';

// Add an entry here when running a new A/B(/C/...) experiment. Variant 'a' must always be the
// control (the existing behavior), because it's also what everyone outside the experiment gets.
// Neither featureFlag nor experimentFlag should be listed in routesConfig.featureFlagsToLoad —
// experiment flags are stripped from context automatically, and variants are loaded lazily
// via useExperimentFeatureFlags.
//
// An A/B experiment (2 variants) can be ended at any time by flipping flags, with the code
// cleanup coming later:
// - featureFlag off: everyone gets 'a'
// - featureFlag on, experimentFlag on: the experiment runs as normal
// - featureFlag on, experimentFlag off: everyone gets 'b'
//
// Careful with experiments that have 3 or more variants: that last combination does NOT pick
// a winner for them. It gives everyone 'a', which is easy to mistake for "everyone gets 'b'".
// - To choose a variant other than 'a', do the code cleanup to make it permanent instead.
// - If everyone should get 'a' until then, turn off featureFlag.
// If the flags do end up set this way, useExperimentFeatureFlags logs a warning (see index.ts).
export const activeExperiments: Experiment[] = [
  {
    featureFlag: 'trustpilot_widget',
    experimentFlag: 'trustpilot_widget_experiment',
    experimentName: 'Trustpilot Widget AB Test',
    numberOfVariants: 2,
  },
  {
    featureFlag: 'visa_verify_during_checkout',
    experimentFlag: 'visa_verify_during_checkout_experiment',
    experimentName: 'Visa Verification During Checkout AB Test',
    numberOfVariants: 2,
  },
];
